<div class="d-flex pt-1">
    <div class="name-wrapper">
        <username-icon context="thread"
                      [userInfos]="userInfos"></username-icon>
    </div>
    <!-- <div class="comment-wrapper"> -->
    <div class="w-100" [ngClass]="{'comment-wrapper': !(review.isEditable || review.isDeletable) || managerCommentUpdateMode}">
        @if(managerCommentUpdateMode && managerListForMentions){
            <manager-comment-input [comment]="review.comment.message"
                                   [commentAuthors]="managerListForMentions"
                                    (onCommentAdded)="onCommentEdited($event)"
                                    (onCancelUpdates)="managerCommentUpdateMode = false"
                                    [setFocus]="null" [editMode]="true" #newCommentComponent></manager-comment-input>
        }@else {
            <p class="p-2 border rounded bg-white review-text" [innerHTML]="review.comment.message.htmlFormat"></p>
            <div class="ps-1 d-flex justify-content-between">
                <span>
                    <span class="ps-1 text-secondary fw-bold fst-italic">
                        @if(review.reviewer.id !== userId){ {{ review.reviewer.fullname }} }@else{ {{'You' | translate }} }
                    </span>
                    <span class="px-1">•</span>
                    <i [matTooltip]="review.date | date: 'medium'" matTooltipPosition="above">{{review.date | time_from_now }}</i>
                </span>
                @if(review.isEditable && review.isDeletable){ 
                    <span class="px-4"></span>
                }
                <div class="d-flex">
                    @if(review.isEditable){
                        <span class="cursor-pointer" (click)="editManagerCommentReview()">
                            <i class="far fa-edit pe-1"></i>{{'comment-card.options.edit' | translate }}
                        </span>
                    }
                    @if(review.isEditable && review.isDeletable){
                        <span class="px-1">•</span>
                    }
                    @if(review.isDeletable){
                        <span class="cursor-pointer" (click)="deleteManagerCommentReview(review)">
                            <i class="far fa-trash-alt pe-1"></i>{{'comment-card.options.delete' | translate }}
                        </span>
                    }
                </div>
            </div>
        }
    </div>
</div>